export const selectStyle = () => ({
  control: (provided, state) => ({
    ...provided,
    borderRadius: 0,
    backgroundColor: "#fff",
    height: "2.25rem",
    border: "none",
    marginBottom: 0,
    padding: 0,
    minHeight: "2.25rem"
  }),
  container: (provided, state) => ({
    ...provided,
    width: "100%"
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: "100%",
    padding: "0 0 0 1rem"
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    display: "none"
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    display: "none"
  }),
  indicatorSeparator: (provided, state) => ({
    ...provided,
    display: "none"
  }),
  input: (provided, state) => ({
    height: "100%"
  }),
  placeholder: (provided, state) => ({
    ...provided,
    fontSize: ".9rem",
    color: "#bbb",
    fontWeight: 300
  }),
  menuList: (provided, state) => ({
    ...provided,
    paddingTop: "0",
    paddingBottom: "0",
    color: "#6D7F92"
  }),
  menu: (provided, state) => ({
    ...provided,
    borderRadius: "0 0 1.25rem 1.25rem",
    height: "15rem",
    top: "1.85rem",
    zIndex: 3,
    backgroundColor: "#F1F2F4",
    overflow: "hidden",
    padding: ".5rem 0",
    border: "none"
  }),
  option: (provided, state) => ({
    ...provided,
    textAlign: "left",

    backgroundColor: state.isFocused ? "#F8F9FA" : "transparent",
    color: "#6D7F92"
  }),
  singleValue: (provided, state) => ({
    ...provided,
    position: "relative",
    transform: "none",
    top: "0"
  }),
  multiValue: (provided, state) => ({
    ...provided,
    backgroundColor: "rgba(47, 71, 194, .75)",
    color: "#fff"
  }),
  multiValueLabel: (provided, state) => ({
    ...provided,
    fontSize: ".9rem",
    color: "#fff"
  })
});

export const avatarStyle = avatar => ({
  backgroundColor: "#EEE",
  backgroundImage: avatar,
  width: "30px",
  height: "30px",
  backgroundSize: "cover",
  backgroundPosition: "center",
  borderRadius: "50%",
  flexShrink: "0",
  marginRight: "0.5rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: "bold",
  fontSize: "1rem",
  textTransform: "uppercase",
  color: "#000"
});

export const singleValueStyle = () => ({
  display: "flex",
  alignItems: "center"
});



// WEBPACK FOOTER //
// ./src/components/Community/WorkPlace/Search/SearchSelect/ReactSelectStyle.js